import * as React from "react";
import CodeForm from "../CodeForm";
import Price from "../Host/Price";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";
import DeviceSelector from "../Selectors/DeviceSelector";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneAlt } from "@fortawesome/pro-solid-svg-icons/faPhoneAlt";
import { faWebcam } from "@fortawesome/pro-solid-svg-icons/faWebcam";
function InstructionBox() {
  var location = useLocation();
  if (!location.pathname.match(/^\/(seite\/\d+\/|welcome|kategorie\/.+\/)?$/)) {
    return null;
  }
  var image = window.age === 16 ? "/img/step3.png" : "/img/step3_f12.png";
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "prodwidth gridreplace center infoline push-bottomsmall c-instructions l-container h-center h-clearfix"
  }, /*#__PURE__*/React.createElement("div", {
    className: "infosection gridreplace whitearrow grid-parent c-instructions__section c-instructions__section--whitearrow"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section1 c-instructions__number"
  }, /*#__PURE__*/React.createElement("span", null, "1")), /*#__PURE__*/React.createElement("div", {
    className: "section2 c-instructions__description"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPhoneAlt,
    className: "mobile-only mr-1"
  }), "Nummer w\u00E4hlen", /*#__PURE__*/React.createElement("small", null, "Jedes ", /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'Girl',
    defaultMessage: "Girl"
  }), " hat eine eigene ", /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'Durchwahl',
    defaultMessage: "Durchwahl"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "section3"
  }, /*#__PURE__*/React.createElement("div", {
    id: "numberSelection flex flex-end"
  }, /*#__PURE__*/React.createElement(DeviceSelector, null))), /*#__PURE__*/React.createElement("div", {
    className: "clear"
  })), /*#__PURE__*/React.createElement("div", {
    className: "infosection gridreplace  greyarrow  grid-parent c-instructions__section c-instructions__section--greyarrow"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section1 c-instructions__number"
  }, /*#__PURE__*/React.createElement("span", null, "2")), /*#__PURE__*/React.createElement("div", {
    className: "section2 c-instructions__description"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "pineingabe"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faWebcam,
    className: "mobile-only mr-1"
  }), "Livecam-Code eingeben", /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("p", {
    className: "mobile-only"
  }, "Den Code bekommst du", /*#__PURE__*/React.createElement("br", null), "vom Girl am Telefon.")), /*#__PURE__*/React.createElement("small", null, "Bekommst du vom ", /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'Girl',
    defaultMessage: "Girl"
  }), " am Telefon")), /*#__PURE__*/React.createElement("div", {
    className: "section3"
  }, /*#__PURE__*/React.createElement("div", {
    id: "codeForm"
  }, /*#__PURE__*/React.createElement(CodeForm, {
    position: 'header'
  }))), /*#__PURE__*/React.createElement("div", {
    className: "clear"
  })), /*#__PURE__*/React.createElement("div", {
    className: "infosection gridreplace  grid-parent c-instructions__section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section1 c-instructions__number"
  }, /*#__PURE__*/React.createElement("span", null, "3")), /*#__PURE__*/React.createElement("div", {
    className: "section2 c-instructions__description"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'spass',
    defaultMessage: "Spaß"
  }), " und Sex haben", /*#__PURE__*/React.createElement("small", null, "Probiere es jetzt")), /*#__PURE__*/React.createElement("div", {
    className: "section3 c-instructions__image"
  }, /*#__PURE__*/React.createElement("img", {
    src: image,
    width: '238',
    height: '62',
    className: "step3img",
    alt: window.layoutSettings.hash === "" ? "Bei Anruf Sex: Spaß und Sex haben" : "Spaß und Sex haben"
  })), /*#__PURE__*/React.createElement("div", {
    className: "clear"
  })), /*#__PURE__*/React.createElement("div", {
    className: "clear"
  })), /*#__PURE__*/React.createElement("div", {
    className: "numberinfo prodwidth gridreplace center push-bottom l-container h-center c-priceinfo",
    id: "numberView"
  }, /*#__PURE__*/React.createElement(Price, null)));
}
export default InstructionBox;